// src/utils/pocketbase.js
import PocketBase from 'pocketbase';

// 必须使用物理 IP，确保与浏览器地址栏中的 IP 一致
const PB_URL = process.env.VUE_APP_PB_URL;

export const pb = new PocketBase(PB_URL);

export default pb;

// 统一封装常用状态
export const isAuthed = () => pb.authStore.isValid;
export const logout = () => pb.authStore.clear();